// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-dcbad518]{min-width:36px;min-height:28px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
